import { useEffect } from 'react'
import Navbar from '@app/components/Navbar'
import Button from '@app/components/Button'
import Footer from '@app/components/Footer'
import { FormattedMessage, useIntl } from 'react-intl'
import Faq from '@app/components/Faq'
import { useNavigate } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import useCampaignHref from '@app/hooks/useCampaignHref'
import { useAppSelector } from '@app/store/hooks'
import { CampaignStatus } from '@app/store/slices/campaign'
import S from './CampaignClosed.styles'

const Home = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const campaign = useAppSelector(state => state.campaign)
  const { href: homeUrl } = useCampaignHref({ requestPath: `/` })

  /**
   * Redirect to the landing page if the program is still open
   */
  useEffect(() => {
    if (campaign.status !== CampaignStatus.Closed) {
      navigate(homeUrl, { replace: true })
    }
  }, [navigate, campaign.status, homeUrl])

  return (
    <>
      <Navbar />
      <S.Main>
        <S.Hero2>
          <S.HeroInner2>
            <S.HeroContent2>
              <h1>
                <FormattedMessage id="closed_page.content.banner.title" />
              </h1>
              <ReactMarkdown>{intl.formatMessage({ id: 'closed_page.content.banner.intro' })}</ReactMarkdown>
              <img src={intl.messages['closed_page.content.banner.image'] as string} alt="" />
              <p className="outroText">
                <FormattedMessage id="closed_page.content.banner.outro" />
              </p>
              <Button to={intl.messages['closed_page.content.banner.button_href'] as string}>
                <FormattedMessage id="closed_page.content.banner.button_text" />
              </Button>
            </S.HeroContent2>
          </S.HeroInner2>
          <span className="pattern" />
        </S.Hero2>
      </S.Main>
      <Faq />

      <Footer />
    </>
  )
}

export default Home
